import React, { Fragment, useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  TranslatedJournalbox,
  TranslatedHeaderJournal,
} from "./components/Journalbox.jsx";
import ReactPaginate from "react-paginate";
import ScaleLoader from "react-spinners/ScaleLoader";
import { withTranslation } from "react-i18next";
import { CheckIcon } from "@heroicons/react/solid";
import { Listbox } from "@headlessui/react";

//////////////////////////////////range date picker /////////////////////
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
/////////////////////////////////////////
import "react-datepicker/dist/react-datepicker.css";
import * as rdrLocales from "react-date-range/dist/locale";

import { Menu, Transition } from "@headlessui/react";
import {
  TranslatedHeaderQueueGroupBox,
  TranslatedQueueGroupBox,
} from "./components/queue-group-box.jsx";
import { Context } from "../../themeContext.js";

//registerLocale("Fr", Fr);

//import DatePicker from "react-datepicker";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function useMounted() {
  const [isMounted, setIsMounted] = useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);
  return isMounted;
}

const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const has_queue_tab = localStorage.getItem("HAS_QUEUE");
const has_call_group_tab = localStorage.getItem("HAS_CALL_GROUP");
const BackendURL = window.BackendURLCmk;
const PER_PAGE = 100;

function Journal({ t }) {
  function test() {
    setSearchText("");
    getAllcollegues();
    // console.log("heeeeeeeeeey", searchText);
  }
  const tabs = [
    {
      id: 1,
      name: t("journal.allcall"),
      state: "all",
    },
    {
      id: 2,
      name: t("journal.internecall"),
      state: "absence_interne",
    },
    {
      id: 3,
      name: t("journal.externecall"),
      state: "absence_externe",
    },
  ];
  const [selected, setSelected] = useState(tabs[0]);

  const [loading, setloading] = useState(false);

  const [activeTab, setActiveTab] = useState("all"); // all, abs, emis, recu,group,queue
  const [recherche, setrecherche] = useState(false);
  const [offset, setOffset] = useState(1);

  const [collegues, setAllcollegues] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [collguesforpagination, setPageCollegues] = useState([]);

  const [allcontact, setContacts] = useState([]);
  const [allcollegue, setCollegue] = useState([]);
  const [allNames, setAllNames] = useState([]);

  const [collegues2, setAllcollegues2] = useState([]);
  const [{ refreshContent }, dispatch] = useContext(Context);

  const getClass = (tabName) => {
    const base =
      "group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 dark:hover:text-gray-400";
    const active = "border-green-500 text-green-600";
    const inactive =
      "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-white";

    return `${base} ${activeTab === tabName ? active : inactive}`;
  };

  const length = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * PER_PAGE} - {offset * PER_PAGE} {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };
  const length2 = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * PER_PAGE} - {collguesforpagination.length}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };

  const [state, setState] = useState([
    {
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // console.log({
  //   activeTab,
  // });

  const filtreDate2 = () => {
    setloading(true);
    var dd = new Date(state[0].startDate).toISOString().split("T")[0];
    var df = new Date(state[0].endDate).toISOString().split("T")[0];
    var lien = window.location.href;
    const var2 = lien.split("/");
    var var4 = var2[2].split(":");
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=${dd}&date_fin=${df}&filter=all`,
        config
      )
      .then((res) => {
        const data = res.data.log_appel.reverse();
        setPageCollegues(data);
        const slice = data.slice((offset - 1) * PER_PAGE, offset * PER_PAGE);
        //array.slice((offset - 1) * PER_PAGE, offset * PER_PAGE)

        // For displaying Data
        const postData = getPostData(slice);

        // Using Hooks to set value
        setAllcollegues(postData);
        setPageCount(Math.ceil(data.length / PER_PAGE));
        setloading(false);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };

  const handleSelectTab = (tab) => {
    setSearchText("");
    if (tab === "all") {
      document.getElementById("notif")?.classList?.remove("bg-opacity-100");
    }
    if (activeTab === tab) {
      dispatch({
        type: "SET_REFRESH_CONTENT_JOURNAL",
      });
    }

    setActiveTab(tab);
    setrecherche(false);
    setOffset(1);
  };

  /***************************************Collegue Names ****************************************/
  const getcollegueNames = () => {
    var config = {
      headers: {
        Authorization: token,
      },
    };
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        const colleagues = Array.isArray(res.data?.collegues)
          ? res.data.collegues
          : [];

        setCollegue(colleagues);

        // const colleaguesMap = colleagues.reduce((acc, colleague) => {
        //   if (!colleague) return acc;

        //   const poste = colleague.poste;
        //   const phone = colleague?.tel_mobil;
        //   const name = colleague.nom;

        //   acc[poste] = name;

        //   if (phone) {
        //     acc[phone] = name;
        //   }

        //   return acc;
        // }, {});

        // setColleaguesContactsNames((prev) => ({
        //   ...prev,
        //   ...colleaguesMap,
        // }));
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };

  /****************************************************Contact Names*************************/
  const getcontactNames = () => {
    var lien = window.location.href;
    const var2 = lien.split("/");
    var var4 = var2[2].split(":");
    var config = {
      headers: {
        Authorization: token,
      },
    };
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        const addressBook = Array.isArray(res.data?.carnet_adresse)
          ? res.data.carnet_adresse
          : [];

        setContacts(addressBook);

        // const contactsMap = addressBook.reduce((acc, contact) => {
        //   const phone = contact?.tel_portable;
        //   const name = [contact?.nom_prenom, contact?.prenom]
        //     .filter(Boolean)
        //     .join(" ")
        //     .trim();

        //   if (phone && name) {
        //     acc[phone] = name;
        //   }
        //   return acc;
        // }, {});

        // setColleaguesContactsNames((prev) => ({ ...prev, ...contactsMap }));
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };

  /****************************Names contact + Collegue Concatination**************************/

  async function getallNames() {
    await Promise.all([getcollegueNames(), getcontactNames()]);

    const NONO = allcontact.concat(allcollegue);
    setAllNames(NONO);

    return NONO;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const getAllcollegues = async () => {
    setloading(true);
    if (activeTab === "all") {
      const config = {
        headers: {
          Authorization: token,
        },
      };
      await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filter=all`,
          config
        )
        .then((res) => {
          setloading(false);

          // console.log("Now Names", allNames);
          const data = res.data.log_appel.reverse();
          setPageCollegues(data);
          //console.log("all");
          setAllcollegues2(data);
          const slice = data.slice((offset - 1) * PER_PAGE, offset * PER_PAGE);
          //array.slice((offset - 1) * PER_PAGE, offset * PER_PAGE)

          // For displaying Data
          const postData = getPostData(slice, allNames);
          // Using Hooks t o set value
          setAllcollegues(postData);

          setPageCount(Math.ceil(data.length / PER_PAGE));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
    if (activeTab === "abs") {
      setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filter=${selected.state}`,
          config
        )
        .then((res) => {
          setloading(false);

          const data = res.data.log_appel.reverse();
          setPageCollegues(data);

          //  console.log(data);
          const slice = data.slice((offset - 1) * PER_PAGE, offset * PER_PAGE);
          //array.slice((offset - 1) * PER_PAGE, offset * PER_PAGE)
          // console.log(slice);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / PER_PAGE));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }

    if (activeTab === "emis") {
      setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filter=emis`,
          config
        )
        .then((res) => {
          setloading(false);

          const data = res.data.log_appel.reverse();
          setPageCollegues(data);
          const slice = data.slice((offset - 1) * PER_PAGE, offset * PER_PAGE);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / PER_PAGE));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
    if (activeTab === "recu") {
      setloading(true);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filter=recu`,
          config
        )
        .then((res) => {
          setloading(false);

          const data = res.data.log_appel.reverse();
          setPageCollegues(data);

          const slice = data.slice((offset - 1) * PER_PAGE, offset * PER_PAGE);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / PER_PAGE));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
    if (activeTab === "group") {
      setloading(true);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogGroupeAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=`,
          config
        )
        .then((res) => {
          setloading(false);

          const data = res.data.log_appel;
          setPageCollegues(data);
          const slice = data.slice((offset - 1) * PER_PAGE, offset * PER_PAGE);

          // For displaying Data
          const postData = getDataGroupQueue(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / PER_PAGE));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            window.location.replace("/");
          } else {
            console.log("AXIOS ERROR: ", err);
          }
          setloading(false);
        });
    }
    if (activeTab === "queue") {
      setloading(true);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogFileAttenteIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=`,
          config
        )
        .then((res) => {
          setloading(false);

          const data = res.data.log_appel;
          setPageCollegues(data);

          const slice = data.slice((offset - 1) * PER_PAGE, offset * PER_PAGE);

          // For displaying Data
          const postData = getDataGroupQueue(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / PER_PAGE));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setOffset(selectedPage + 1);
  };

  const getPostData = (data) => {
    return data.map((post) => (
      <TranslatedJournalbox
        person={post}
        key={post.id}
        toggle={getAllcollegues}
        genre={selected.state}
      />
    ));
  };
  const getDataGroupQueue = (data) => {
    return data.map((item) => (
      <TranslatedQueueGroupBox item={item} type={activeTab} key={item.id} />
    ));
  };

  useEffect(() => {
    if (recherche == true) {
      filterData(searchText);
    } else {
      getallNames();
      getAllcollegues();
    }
  }, [activeTab, offset, refreshContent]);

  const [searchText, setSearchText] = useState("");
  const excludeColumns = [
    "id_appel",
    "dstchannel",
    "accountcode",
    "amaflags",
    " billsec",
    "calldate_answer",
    "calldate_start ",
    "channel",
    // "clid",
    "dcontext ",
    "disposition",
    "dstchannel",
    "duration",
    "etat_queue",
    "genre_appel",
    "id",
    "id_enregistrement",
    "lastapp",
    "lastdata",
    "ringingsec",
    "sda",
    "sens_appel",
    "type_appel",
    "uniqueid",
    "userfield",
    "valeur_saisie",
  ];
  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue === "") getAllcollegues();
    else {
      const filteredData = collegues2.filter((item) => {
        return Object.keys(item).some((key) =>
          excludeColumns.includes(key)
            ? false
            : item[key]?.toString()?.toLowerCase()?.includes(lowercasedValue)
        );
      });

      setPageCollegues(filteredData);
      setOffset(1);
      const slice = filteredData.slice(
        (offset - 1) * PER_PAGE,
        offset * PER_PAGE
      );

      const postData = getPostData(slice);

      // Using Hooks to set value
      setAllcollegues(postData);
      setPageCount(Math.ceil(filteredData.length / PER_PAGE));
      //getPostData(filteredData);
    }
  };
  const handleChange = (value) => {
    setrecherche(true);
    setSearchText(value);
    filterData(value);
  };

  if (loading == false) {
    return (
      <div className="content pb-4 flex flex-col h-screen">
        <div className="py-4">
          <div className="md:flex md:items-center md:justify-between mb-4 mx-4 sticky top-0">
            <div className="flex-1 min-w-1 flex ">
              <h2 className=" dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                {t("journal.title")}{" "}
              </h2>
            </div>
            <Menu as="div" className="ml-4 relative flex-shrink-0">
              {({ open }) => (
                <>
                  <div>
                    <div className="flex text-sm text-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-offset-green-300 focus:ring-white"></div>
                  </div>
                  <Transition
                    show={open}
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items
                    // static
                    // className="origin-top-right absolute z-10 right-0 mt-2 px-4 space-y-4 w-56 rounded-md shadow-lg py-3 bg-white  text-sm text-gray-700 dark:text-gray-300 divide-y divide-gray-100 dark:divide-gray-700 ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800"
                    >
                      <DateRangePicker
                        onChange={(item) => {
                          setState([item.selection]);
                          filtreDate2();
                        }}
                        showSelectionPreview={true}
                        //onChange={handleSelect(state)}
                        //moveRangeOnFirstSelection={false}
                        months={2}
                        ranges={state}
                        direction="horizontal"
                        //     preventSnapRefocus={true}
                        calendarFocus="backwards"
                        //onChange={handleSelect}
                        className="absolute -ml-96 mt-8"
                        locale={rdrLocales.fr}
                      />
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>
            <div className="mt-1  relative rounded-md shadow-sm">
              <input
                type="text"
                className=" dark:bg-gray-600 dark:text-gray-200 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                placeholder={t("findcall")}
                value={searchText}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                  webKitBoxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  boxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                }}
              />
              <div className="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none ">
                <svg
                  className="h-5 w-5 text-gray-400 "
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              {searchText != "" ? (
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 pl-3 flex items-center dark:text-gray-100 transition-all hover:bg-gray-100"
                  onClick={() => {
                    test();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              ) : (
                <div></div>
              )}
            </div>{" "}
          </div>
        </div>

        <div className="dark:border-gray-800 border-b border-gray-200 dark:text-white transition-all">
          {collguesforpagination.length !== 0 ? (
            <div className="flex">
              <div className="flex" style={{ marginLeft: "auto", order: "2" }}>
                <span
                  className="text-gray-500 dark:text-white"
                  //  style={{ marginLeft: "auto", order: "2" }}
                >
                  {offset == pageCount ? length2() : length()}
                </span>

                <ReactPaginate
                  previousLabel={"<"}
                  previousClassName={
                    "p-0.5 md:p-1.5 lg:p-1.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center  border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                  }
                  nextLabel={">"}
                  nextClassName={
                    "pl-1.5 lg:pl-2.5 md:pl-2.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center p-1.5 border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                  }
                  breakLabel={"countforpagination"}
                  breakClassName={"hidden"}
                  pageClassName={
                    "hidden relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                  }
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  containerClassName={
                    "relative z-0 inline-flex rounded-md  -space-x-px"
                  }
                  activeClassName=""
                  forcePage={offset - 2}
                />
              </div>
            </div>
          ) : (
            <div></div>
          )}
          <nav className="flex-1 min-w-4 " aria-label="Tabs">
            <a
              href="#"
              className={getClass("all")}
              onClick={() => handleSelectTab("all")}
            >
              <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                {t("journal.allcall")}{" "}
              </span>
              <span className="lg:hidden md:hidden">Tous</span>
            </a>

            <a
              href="#"
              className={getClass("recu")}
              aria-current="page"
              onClick={() => handleSelectTab("recu")}
            >
              <span>{t("incoming.calls")}</span>
            </a>

            <a
              href="#"
              className={getClass("emis")}
              onClick={() => handleSelectTab("emis")}
            >
              <span>{t("outgoing.calls")}</span>
            </a>
            <a href="#" className={getClass("abs")}>
              {/* <span>{t("missedcalls")}</span> */}
              <Listbox
                value={selected}
                onChange={(e) => {
                  setSelected(e);
                  handleSelectTab("abs");
                }}
              >
                {({ open }) => (
                  <>
                    <div className="flex">
                      <Listbox.Button className="flex">
                        <div className="flex items-center gap-1 justify-center">
                          <span className="text-sm font-medium">
                            {t("missedcalls")}
                          </span>
                          <span className="text-xs mt-0.5 font-medium">
                            ({selected.name})
                          </span>
                        </div>

                        <span className=" pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 ml-1 mt-1"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </span>
                      </Listbox.Button>

                      <Transition
                        show={open}
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Listbox.Options className=" absolute  mt-8 w-38 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {tabs.map((person) => (
                            <Listbox.Option
                              key={person.id}
                              className={({ active }) =>
                                classNames(
                                  active
                                    ? "text-white bg-green-500"
                                    : "text-gray-900",
                                  "cursor-default select-none relative py-2 pl-3 pr-9"
                                )
                              }
                              value={person}
                            >
                              {({ selected, active }) => (
                                <>
                                  <div className="flex items-center">
                                    <span
                                      className={classNames(
                                        selected
                                          ? "font-semibold"
                                          : "font-normal",
                                        "ml-3 block truncate"
                                      )}
                                    >
                                      {person.name}
                                    </span>
                                  </div>

                                  {selected ? (
                                    <span
                                      className={classNames(
                                        active
                                          ? "text-white"
                                          : "text-indigo-600",
                                        "absolute inset-y-0 right-0 flex items-center pr-4"
                                      )}
                                    >
                                      <CheckIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    </span>
                                  ) : null}
                                </>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            </a>
            {has_queue_tab && (
              <a
                href="#"
                className={getClass("queue")}
                onClick={() => handleSelectTab("queue")}
              >
                <span>{t("log.queue")}</span>
              </a>
            )}
            {has_call_group_tab && (
              <a
                href="#"
                className={getClass("group")}
                onClick={() => handleSelectTab("group")}
              >
                <span>{t("log.group")}</span>
              </a>
            )}
          </nav>
        </div>

        {collguesforpagination.length !== 0 ? (
          <div className=" dark:bg-gray-900 flex flex-col overflow-y-auto ">
            <div className=" dark:bg-gray-900">
              <div className=" dark:bg-gray-900 align-middle inline-block min-w-full shadow  border-b border-gray-200">
                <table className="min-w-full dark:bg-gray-900 dark:text-white transition-all">
                  {["queue", "group"].includes(activeTab) ? (
                    <TranslatedHeaderQueueGroupBox type={activeTab} />
                  ) : (
                    <TranslatedHeaderJournal />
                  )}
                  <tbody className="bg-white">{collegues}</tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className="justify-center mt-64 pr-96">
            <h2 className="pl-44 dark:text-white text-lg font-medium leading-7  sm:text-3xl sm:truncate text-gray-400">
              {t("nocallhistory")}{" "}
            </h2>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="content pb-4">
        <div className="py-4">
          <div className="md:flex md:items-center md:justify-between mb-4 mx-4 sticky top-0">
            <div className="flex-1 min-w-1 flex ">
              <h2 className="dark:text-white  text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                {t("journal.title")}{" "}
              </h2>
            </div>
            <Menu as="div" className="ml-4 relative flex-shrink-0">
              {({ open }) => (
                <>
                  <Transition
                    show={open}
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items>
                      <DateRangePicker
                        onChange={(item) => {
                          setState([item.selection]);
                          // console.log(state);
                          filtreDate2();
                        }}
                        showSelectionPreview={true}
                        //onChange={handleSelect(state)}
                        //moveRangeOnFirstSelection={false}
                        months={2}
                        ranges={state}
                        direction="horizontal"
                        //     preventSnapRefocus={true}
                        calendarFocus="backwards"
                        //onChange={handleSelect}
                        className="absolute -ml-96 mt-8"
                        locale={rdrLocales.fr}
                      />
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>
            <div className="mt-1  relative rounded-md shadow-sm">
              <input
                type="text"
                className="dark:bg-gray-600 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                placeholder={t("findcall")}
                value={searchText}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                  webKitBoxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  boxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                }}
              />
              <div className="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none ">
                <svg
                  className="h-5 w-5 text-gray-400 dark:text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <div className="flex flex-wrap justify-center  mt-64">
            <ScaleLoader
              color="#109669"
              loading={loading}
              size={50}
              width={4}
              height={68}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation("common")(Journal);
